import { useAssetDetailsContext } from "@/pages/asset-details/context/assetDetailsContext";
import { Button } from "@mui/material";
import Grid2 from "@mui/material/Grid2";
import { createStyles, makeStyles } from "@mui/styles";
import type { EditableCallbackParams } from "ag-grid-community";
import { useNavigate } from "react-router-dom";

const getCompactPath = (fullPath: string) => {
	if (!fullPath) return "";
	const parts = fullPath.split("/");
	if (parts.length <= 3) return fullPath;
	return `${parts[0]}/.../${parts[parts.length - 2]}/${parts[parts.length - 1]}`;
};

const useStyles = makeStyles((theme) =>
	createStyles({
		assetLink: {
			textDecoration: "none",
			color: "#1976d2",
			cursor: "pointer",
			textAlign: "left",
			justifyContent: "flex-start",
			textTransform: "none",
			padding: "4px 8px",
			fontSize: "14px",
			fontWeight: 400,
			"&:hover": {
				textDecoration: "underline",
				backgroundColor: "rgba(25, 118, 210, 0.04)",
			},
		},
	}),
);

type Props = EditableCallbackParams;

export const AssetLinkRenderer = ({ data }: Props) => {
	const classes = useStyles();
	const navigate = useNavigate();
	const {
		state: { assetSearchName },
	} = useAssetDetailsContext();

	const handleAssetClick = () => {
		if (data?.AssetId) {
			navigate(`/work-orders/${data.AssetId}`, { replace: false });
		}
	};

	if (data?.id === -1) {
		return (
			<Grid2
				container
				spacing={1}
				style={{ alignItems: "center", justifyContent: "center" }}
			>
				<Grid2 style={{ alignItems: "center", justifyContent: "center" }}>
					{assetSearchName}
				</Grid2>
			</Grid2>
		);
	} else if (data?.id !== -1 && data?.AssetId) {
		const compactPath = getCompactPath(data?.FullPath || "");
		const displayText = compactPath || data?.AssetName || "";

		return (
			<Button
				onClick={handleAssetClick}
				className={classes.assetLink}
				title={data?.FullPath}
				fullWidth
			>
				{displayText}
			</Button>
		);
	} else {
		const compactPath = getCompactPath(data?.FullPath || "");
		const displayText = compactPath || data?.AssetName || "";
		return <div title={data?.FullPath}>{displayText}</div>;
	}
};
